import { useState } from 'react';

import { render as renderCustom } from '../entry';

import { client, ClientProvider } from "@magalu/rave/graphql";
import { ConfigProvider } from "@magalu/rave/config/Provider";

// Data Source Configs
import { configs as dataSourceConfigs } from '../datasource/config';
const { cachePolicies = {}, localTypeDefs,  linkMiddlewares = [] } = dataSourceConfigs ;

import clientConfig from '../containers/client-config';


const CustomRender = ({ Component, pageProps }) => {
  return renderCustom({ Component, pageProps });
};

export const withRaveContexts = (children, clientEnvs = {}) => {
  const [configEnvs] = useState({ client: { ...clientConfig, ...clientEnvs } });
  let clientProviderParams = {};

  clientProviderParams = {
    config: {
      ...({
  "configsDir": "config",
  "serverDefaultOptions": {
    "query": {
      "errorPolicy": "all",
      "fetchPolicy": "no-cache"
    }
  }
} || {}),
      ...(configEnvs?.client?.datasource?.graphql || {})
    },
  };
  clientProviderParams['cachePolicies'] = cachePolicies;
  clientProviderParams['localTypeDefs'] = localTypeDefs;
  clientProviderParams['linkMiddlewares'] = linkMiddlewares;
  clientProviderParams['configEnv'] = configEnvs.client;
  return (
    <ClientProvider {...clientProviderParams}>
      <ConfigProvider config={configEnvs}>{children}</ConfigProvider>
    </ClientProvider>
  );
};

export default function CustomApp({ Component, pageProps = {} }) {
  const clientEnvs = pageProps.clientConfig;
  let parsedPageProps = {...pageProps};

    return withRaveContexts(<CustomRender Component={Component} pageProps={parsedPageProps} />, clientEnvs);
};
